<div class="page-content">
    <div class="container">
        <router-outlet></router-outlet>
    </div>
</div>


